module.exports = __webpack_public_path__ + "static/media/Group 595.200f6f66.png";